import styled from 'styled-components'

export const TillContainer = styled.div`
  text-align: center;
  display: grid;
`